'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  padding-left: 16px;\n  padding-right: 16px;\n  padding-top: 16px;\n  padding-bottom: 16px;\n\n  border-radius: 8px;\n  background-color: white;\n  overflow: hidden;\n\n  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08), \n              0 2px 4px 0 rgba(0, 0, 0, 0.06);\n'], ['\n  padding-left: 16px;\n  padding-right: 16px;\n  padding-top: 16px;\n  padding-bottom: 16px;\n\n  border-radius: 8px;\n  background-color: white;\n  overflow: hidden;\n\n  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08), \n              0 2px 4px 0 rgba(0, 0, 0, 0.06);\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _flex = require('./flex');

var _flex2 = _interopRequireDefault(_flex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Card = (0, _styledComponents2.default)(_flex2.default)(_templateObject);

Card.displayName = 'Card';

exports.default = Card;